import { positionOptions } from '@/constants/option';

export const convertInfoValue = (value: string) => {
	switch (value) {
		case '공지사항':
			return 'notice';
		case '소식지':
			return 'newsletter';
		case '연구동향':
			return 'trend';
		case '갤러리':
			return 'gallery';
		case '자유게시판':
			return 'forum';
		case '연간기부금 모금액 및 활용실적':
			return 'donation';
		default:
			return 'notice';
	}
};

export const convertPaymentValue = (value: string) => {
	switch (value) {
		case '일반회원':
			return '200,000';
		case '학생회원':
			return '100,000';
		default:
			return '0';
	}
};

export const convertPaymentRegisterValue = (value: string) => {
	switch (value) {
		case '일반회원':
			return '200,000';
		case '학생회원':
			return '100,000';
		case '특별회원':
			return '0';
		case '명예회원':
			return '0';
		default:
			return '0';
	}
};

export const convertPublicationPaymentValue = (value: string) => {
	switch (value) {
		case '기본':
			return '400,000';
		case '속보':
			return '600,000';
		default:
			return '400,000';
	}
};

export const convertPositionValue = (value: string) => {
	const match = positionOptions.find((option) => option.value === value);
	return match ? match.value : '기타(직접입력)';
};
